export default __webpack_public_path__ + "static/media/diagonal.b9acf4d1.png";